import React from 'react';
import { Switch } from 'components/UI/V3/Forms/Switch/Switch';
import { RadioGroup } from 'components/UI/V3/Forms/RadioGroup';
import { LateCheckoutFeeType, LATE_CHECKOUT_FEE_TYPES } from 'model/Service';
import styles from './LateCheckoutFeeConfig.module.scss';

interface RadioGroupLateCheckoutOption {
    value: LateCheckoutFeeType;
    inlineLabel: string;
    description?: string;
}

interface LateCheckoutFeeConfigProps {
    lateCheckoutFee: {
        enabled: boolean;
        type?: LateCheckoutFeeType;
        gracePeriod: number;
    };
    onLateCheckoutFeeChange: (config: { enabled: boolean; type?: LateCheckoutFeeType; gracePeriod: number }) => void;
    className?: string;
}

export const LateCheckoutFeeConfig: React.FC<LateCheckoutFeeConfigProps> = ({
    lateCheckoutFee,
    onLateCheckoutFeeChange,
    className
}) => {
    // Generate late checkout fee options for boarding
    const getLateCheckoutOptions = (): RadioGroupLateCheckoutOption[] => {
        return [
            {
                value: LATE_CHECKOUT_FEE_TYPES.FIXED_FEE,
                inlineLabel: 'Fixed Fee'
            },
            {
                value: LATE_CHECKOUT_FEE_TYPES.PER_HOUR,
                inlineLabel: 'Per Hour'
            },
            {
                value: LATE_CHECKOUT_FEE_TYPES.ADDITIONAL_NIGHT,
                inlineLabel: 'Additional Night'
            }
        ];
    };

    const handleSwitchChange = (enabled: boolean) => {
        // Use 'fixed_fee' as default for boarding
        const defaultType = LATE_CHECKOUT_FEE_TYPES.FIXED_FEE;

        onLateCheckoutFeeChange({
            enabled,
            type: enabled ? defaultType : undefined,
            gracePeriod: lateCheckoutFee.gracePeriod
        });
    };

    const handleTypeChange = (type: LateCheckoutFeeType) => {
        onLateCheckoutFeeChange({
            ...lateCheckoutFee,
            type
        });
    };

    const options = getLateCheckoutOptions();

    return (
        <div className={`${styles.container} ${className || ''}`}>
            <div className={styles.switchSection}>
                <span className={styles.switchLabel}>Late Checkout Fee</span>
                <Switch
                    checked={lateCheckoutFee.enabled}
                    onChange={handleSwitchChange}
                />
            </div>

            {lateCheckoutFee.enabled && (
                <div className={styles.optionsSection}>
                    <div className={styles.radioGrid}>
                        <RadioGroup<LateCheckoutFeeType>
                            className={styles.radioGroup}
                            options={options}
                            value={lateCheckoutFee.type || LATE_CHECKOUT_FEE_TYPES.FIXED_FEE}
                            onChange={handleTypeChange}
                        />
                    </div>
                </div>
            )}
        </div>
    );
};
